var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-size-100 margin-top-content"},[_c('b-btn',{staticClass:"position-fixed rounded-circle border-0 p-2",staticStyle:{"background-color":"#0ca788"},attrs:{"id":"open","href":_vm.spreadsheetLink}},[_c('img',{attrs:{"height":"50px","width":"50px","src":require("../assets/images/open_icon.png")}})]),_c('iframe',{staticClass:"w-100 h-100",attrs:{"src":'https://docs.google.com/spreadsheets/d/' +
      _vm.spreadsheetId +
      '/edit?rm=minimal'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }